/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { personSchema } from '../person-schema';

export const personListItemSchema = personSchema.extend({
  avatarUrl: z.string().nullable().optional(),
});

export type IPersonListItem = z.infer<typeof personListItemSchema>;

export const listPeopleResponseSchema = createApiResponseSchema(
  z.array(personListItemSchema),
) as import('zod').ZodSchema<IAPI<IPersonListItem[]>>;

export type IListPeopleResponse = IAPI<IPersonListItem[]>;
